import React, { useEffect, useState } from 'react';
import { clearLocalSession } from './Http/auth/session';
import ReactDOM from 'react-dom/client';
import Routes from './routes';
import { Provider, useDispatch } from 'react-redux';
import { store } from './redux/store';
import './style.css';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Cookies } from 'react-cookie';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ENVIRONMENT } from './Http/API';
import { addSubscriptions } from './redux/slices/subscriptions';
import { Button, Modal, Spin } from 'antd';
import eventBus from './events/eventBus';
const cookie = new Cookies();


const App = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAppReady, setIsAppReady] = useState(false);
  const dispatch = useDispatch();
  const stripePromise = loadStripe(ENVIRONMENT.stripe_public_key);

  const handleLogout = () => {
    cookie.remove('Authorization', { path: '/' });
    dispatch(addSubscriptions({}));
    clearLocalSession();
    window.location.href = '/login';
  };

  const checkForInactivity = () => {
    const expireTime = parseInt(localStorage.getItem('expirationTime'), 10);
    if (expireTime && expireTime < Date.now()) {
      setIsModalVisible(true);
    }
  };

  const updateExpireTime = () => {
    const token = localStorage.getItem('token');
    if (token) {
      const expireTime = Date.now() + 7200000; // 2 hours
      localStorage.setItem('expirationTime', expireTime);
    }
  };

  useEffect(() => {
    // Initialize session expiration check
    const interval = setInterval(checkForInactivity, 10000); // Check every 10 seconds
    setIsAppReady(true); // Mark the app as ready after setting up the interval
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Add user activity listeners to update expiration time
    const events = ['click', 'keypress', 'scroll', 'mousemove'];
    const updateTimeThrottled = () => updateExpireTime();
    events.forEach((event) => document.addEventListener(event, updateTimeThrottled));

    return () => {
      events.forEach((event) => document.removeEventListener(event, updateTimeThrottled));
    };
  }, []);

  useEffect(() => {
    // Handle unauthorized events
    const handleUnauthorized = () => {
      setIsModalVisible(true);
    };

    eventBus.on('unauthorized', handleUnauthorized);
    return () => {
      eventBus.off('unauthorized', handleUnauthorized);
    };
  }, []);

  if (!isAppReady) {
    // Use a lightweight spinner while the app initializes
    return (
      <div className="spinner">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      {isModalVisible ? (
        <Modal
          title="Session Expired"
          visible={isModalVisible}
          onOk={handleLogout}
          okText="Login Again"
          closable={false}
          footer={[
            <Button type="primary" key="logout" onClick={handleLogout}>
              Login Again
            </Button>,
          ]}
          maskClosable={false}
        >
          <p>Your session has expired. Please log in again to continue.</p>
        </Modal>
      ) : (
        <Routes />
      )}
    </Elements>
  );
};

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>,
  // </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
